import { render, staticRenderFns } from "./DiscountCustomerBreakdown.vue?vue&type=template&id=db34bd94&scoped=true"
import script from "./DiscountCustomerBreakdown.vue?vue&type=script&lang=js"
export * from "./DiscountCustomerBreakdown.vue?vue&type=script&lang=js"
import style0 from "./DiscountCustomerBreakdown.vue?vue&type=style&index=0&id=db34bd94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db34bd94",
  null
  
)

export default component.exports